module.exports = __webpack_public_path__ + "img/V63.339c95d6.jpg";